import {configureStore} from "@reduxjs/toolkit";
import OpeningHoursSlice from "./slices/businessSlice";
import HolidaysSlice from "./slices/holidaysSlice";
import ReviewsSlice from "./slices/reviewsSlice";
import HamburgerSlice from "./slices/hamburgerSlice";
import GallerySlice from "./slices/gallerySlice";
import GalleryPeopleSlice from "./slices/galleryPeopleSlice";

export const store = configureStore({
    reducer: {
        business: OpeningHoursSlice,
        holidays: HolidaysSlice,
        reviews: ReviewsSlice,
        hamburger: HamburgerSlice,
        gallery: GallerySlice,
        galleryPeople: GalleryPeopleSlice
    }
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;